import { invokeEdgeFunction } from '../supabase/supabaseFunctions';
import type { GoogleSheetsExportPayload, GoogleSheetsExportResponse } from './types';

export class GoogleSheetsService {
  async createSheet(payload: GoogleSheetsExportPayload): Promise<string> {
    const { data, error } = await invokeEdgeFunction<GoogleSheetsExportResponse>(
      'create-google-sheet',
      payload
    );

    if (error || !data?.spreadsheetUrl) {
      throw error || new Error('Spreadsheet URL was not returned by the server.');
    }

    return data.spreadsheetUrl;
  }
}

export const googleSheetsService = new GoogleSheetsService();
